module.exports = __webpack_public_path__ + "img/soundwave.27f24bd7.svg";